import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const PartnershipInquiry = () => {
  const [formData, setFormData] = useState({
    organizationName: '',
    contactName: '',
    email: '',
    phone: '',
    organizationType: 'club',
    country: '',
    message: '',
    agreeTerms: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      alert('Partnership inquiry submitted successfully! Our team will contact you within 48 hours.');
      setIsSubmitting(false);
      setFormData({
        organizationName: '',
        contactName: '',
        email: '',
        phone: '',
        organizationType: 'club',
        country: '',
        message: '',
        agreeTerms: false
      });
    }, 1500);
  };

  const organizationTypes = [
    { value: 'club', label: 'Football Club' },
    { value: 'academy', label: 'Football Academy' },
    { value: 'agency', label: 'Sports Agency' },
    { value: 'media', label: 'Media Organization' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Handshake" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground font-headline">
            Partnership Inquiry
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Join our global network of football excellence
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Organization Name"
            type="text"
            placeholder="Enter organization name"
            value={formData?.organizationName}
            onChange={(e) => handleInputChange('organizationName', e?.target?.value)}
            required
          />

          <Input
            label="Contact Person Name"
            type="text"
            placeholder="Enter your full name"
            value={formData?.contactName}
            onChange={(e) => handleInputChange('contactName', e?.target?.value)}
            required
          />

          <Input
            label="Email Address"
            type="email"
            placeholder="contact@organization.com"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            required
          />

          <Input
            label="Phone Number"
            type="tel"
            placeholder="+44 20 1234 5678"
            value={formData?.phone}
            onChange={(e) => handleInputChange('phone', e?.target?.value)}
            required
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Organization Type <span className="text-error">*</span>
            </label>
            <select
              value={formData?.organizationType}
              onChange={(e) => handleInputChange('organizationType', e?.target?.value)}
              className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-300"
              required
            >
              {organizationTypes?.map((type) => (
                <option key={type?.value} value={type?.value}>
                  {type?.label}
                </option>
              ))}
            </select>
          </div>

          <Input
            label="Country"
            type="text"
            placeholder="Enter country"
            value={formData?.country}
            onChange={(e) => handleInputChange('country', e?.target?.value)}
            required
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            Message <span className="text-error">*</span>
          </label>
          <textarea
            value={formData?.message}
            onChange={(e) => handleInputChange('message', e?.target?.value)}
            placeholder="Tell us about your organization and partnership interests..."
            rows={5}
            className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-300 resize-none"
            required
          />
        </div>

        <Checkbox
          label="I agree to the terms and conditions and privacy policy"
          checked={formData?.agreeTerms}
          onChange={(e) => handleInputChange('agreeTerms', e?.target?.checked)}
          required
        />

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            type="submit"
            variant="default"
            fullWidth
            loading={isSubmitting}
            iconName="Send"
            iconPosition="right"
            disabled={!formData?.agreeTerms}
          >
            Submit Partnership Inquiry
          </Button>
          <Button
            type="button"
            variant="outline"
            fullWidth
            iconName="Phone"
            iconPosition="left"
            onClick={() => window.location.href = 'tel:+442012345678'}
          >
            Call Us Directly
          </Button>
        </div>

        <div className="bg-muted rounded-lg p-4 flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-xs md:text-sm text-muted-foreground">
            <p className="font-semibold text-foreground mb-1">What happens next?</p>
            <p>Our partnership team will review your inquiry and contact you within 48 hours to discuss collaboration opportunities and next steps.</p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PartnershipInquiry;